import { render, staticRenderFns } from "./Violations.vue?vue&type=template&id=157724aa"
import script from "./Violations.vue?vue&type=script&lang=js"
export * from "./Violations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports